import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = ({ compact = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      toast.success("You're in. Stay in motion.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid="newsletter-form" onSubmit={submit} className={`flex w-full ${compact ? "max-w-sm" : "max-w-xl"} border-b border-stone/30 focus-within:border-mist transition-colors`}>
      <input
        data-testid="newsletter-email-input"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="EMAIL ADDRESS"
        className="flex-1 bg-transparent py-4 text-sm tracking-[0.15em] uppercase placeholder:text-stone/35 focus:outline-none"
        aria-label="Email address"
      />
      <button
        data-testid="newsletter-submit-button"
        type="submit"
        disabled={loading}
        className="flex items-center gap-2 font-display uppercase tracking-[0.2em] text-sm text-stone hover:text-mist transition-colors disabled:opacity-50"
      >
        {loading ? "Joining" : "Subscribe"} <ArrowRight size={16} />
      </button>
    </form>
  );
};
